export const ADSENSE_CLIENT = "ca-pub-1943097022556556";

export function isAdSensePage(url: URL): boolean {
  return (
    ["name.jieyiai.dev", "en.jieyiai.dev"].includes(url.hostname) &&
    url.protocol === "https:" &&
    ["/", "/surnames", "/meaning", "/pricing"].includes(url.pathname) &&
    !url.searchParams.has("result")
  );
}

export function loadAdSense(): void {
  if (
    !isAdSensePage(new URL(window.location.href)) ||
    document.querySelector("script[data-jieyi-adsense]")
  )
    return;
  const script = document.createElement("script");
  script.async = true;
  script.crossOrigin = "anonymous";
  script.dataset.jieyiAdsense = "true";
  script.nonce = document.querySelector<HTMLScriptElement>("script[nonce]")?.nonce ?? "";
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
  document.head.appendChild(script);
}
